import SearchButton from "components/Button/SearchButton"
import Dropdown from "components/Input/Dropdown"
import { useEffect, useState } from "react"
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString } from "utils/Constant"
import { ApiGetRoomByKostId } from "utils/constants/api"
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import useFetch from "utils/hooks/useFetch"

export default function Room(){
    const { data: roomData, fetch: getRoom } = useFetch(ApiGetRoomByKostId)

    const [roomNumber, setRoomNumber] = useState(EmptyString)
    const [floorLevel, setFloorLevel] = useState(EmptyString)
    const [roomType, setRoomType] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)

    // Dropdown Options
    const [roomTypeOptions, setRoomTypeOptions] = useState([])
    const [statusOptions, setStatusOptions] = useState([])

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState(false)
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    useEffect(() => {
        setLoading(true)

        Promise.all([
            fGetRoom()
        ]).then(() => {
            setLoading(false)
        })        
    }, [])

    // Function Api
    async function fGetRoom(){
        await getRoom({
            data: {
                kostId: localStorage.getItem("KostId")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Function
    function fSearchBtnClick(){

    }

    function fEnterKeyDown(){

    }

    function fRoomStatus(roomStatusCode){
        let style = ''
        switch (roomStatusCode) {
            case '1':
                style = "bg-amber-400"
                break
            case '2':
                style = "bg-red-800"
                break
            case '3':
                style = "bg-slate-500"
                break
            case '4':
                style = "bg-orange-600"
                break
            case '5':
                style = "bg-green-400"
                break
            default:
                style = "bg-white"
        }

        return style
    }

    return(
        <div className="flex flex-col gap-2">
            <div>
                <div>
                    <span className="font-semibold text-2xl">Room</span>
                </div>
                <hr />
            </div>

            <div className="gap-5 justify-between mt-5 hidden">
                <div className="flex gap-4 w-full">
                    <div className="flex flex-col gap-2 w-full">
                        <span>Room Number</span>
                        <input className="input" value={ roomNumber } onChange={(e) => { setRoomNumber(e.target.value) }} onKeyDown={(e) => { fEnterKeyDown(e) }} />
                    </div>
                    <div className="flex flex-col gap-2 w-full">
                        <span>Floor Level</span>
                        <input className="input" value={ floorLevel } onChange={(e) => { setFloorLevel(e.target.value) }} onKeyDown={(e) => { fEnterKeyDown(e) }} />
                    </div>
                    <div className="flex flex-col gap-2 w-full">
                        <span>Room Type</span>
                        <Dropdown options={ roomTypeOptions } value={ roomType } onChange={(e) => { setRoomType(e.value) }} />
                    </div>
                    <div className="flex flex-col gap-2 w-full">
                        <span>Status</span>
                        <Dropdown options={ statusOptions } value={ status } onChange={(e) => { setStatus(e.value) }} />
                    </div>
                </div>
                <div>
                    <div className="flex items-end h-full">
                        <SearchButton onClick={() => { fSearchBtnClick() }} />
                    </div>
                </div>
            </div>

            <div className="py-2 px-3 flex flex-wrap gap-4">
                <div className="flex items-center gap-2">
                    <div className="bg-amber-400 w-4 h-4 rounded"></div>
                    <span>Available</span>
                </div>
                <div className="flex items-center gap-2">
                    <div className="bg-red-800 w-4 h-4 rounded"></div>
                    <span>Occupied</span>
                </div>
                <div className="flex items-center gap-2">
                    <div className="bg-slate-500 w-4 h-4 rounded"></div>
                    <span>Under Maintenance</span>
                </div>
                <div className="flex items-center gap-2">
                    <div className="bg-orange-600 w-4 h-4 rounded"></div>
                    <span>Booked</span>
                </div>
                <div className="flex items-center gap-2">
                    <div className="bg-green-400 w-4 h-4 rounded"></div>
                    <span>Available Soon</span>
                </div>
            </div>
            
            <div className="flex flex-wrap gap-4 mt-5">
                { roomData?.data?.map((data, i) => {
                    return(
                        <button className={ `border hover:shadow-lg transition-all rounded-md p-4 ${ fRoomStatus(data.roomStatus)  }` } key={i} >
                            <div className="">
                                <span className="font-semibold">{ data.roomNumber }</span>
                            </div>
                        </button>   
                    )
                }) }
                
            </div>
            
            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading ? (<LoadingModal />) : (<div />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}